import React from 'react'

const Loading = ({loadingText = 'Loading...'}) => (
  <div className="outer">
    <div className="middle">
      <div className="inner">
        <div className="sk-folding-cube">
          <div className="sk-cube1 sk-cube"/>
          <div className="sk-cube2 sk-cube"/>
          <div className="sk-cube4 sk-cube"/>
          <div className="sk-cube3 sk-cube"/>
        </div>

        <div className="loading-txt">{loadingText}</div>
      </div>
    </div>
  </div>
)

export default Loading
